module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesElegant.00cfe54.jpg";